(function () {
  if (window.__bbStockFilterInit) return;
  window.__bbStockFilterInit = true;

  const FILTER_CLASS = 'filter-active';
  const ACTIVE_CLASS = 'active';
  const OOS_CLASS = 'is-out-of-stock';
  const TOGGLE_SEL = '.variant-stock-toggle';
  const OPTIONS_SEL = 'product-options, [data-product-options]';
  const UNAVAILABLE_SEL = '.product-option__label--unavailable';
  const CSS_HREF_MARKER = 'instock-vs-all-variants';

  function ensureStylesheet() {
    if (document.querySelector('link[href*="' + CSS_HREF_MARKER + '"]')) return;
    var script = document.querySelector('script[src*="' + CSS_HREF_MARKER + '"]');
    if (!script || !script.src) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = script.src.replace(/\.js(\?|$)/, '.css$1');
    document.head.appendChild(link);
  }

  function productIdFrom(el) {
    if (!el) return null;
    return el.getAttribute('data-product-id') || el.getAttribute('data-product-options') || null;
  }

  /**
   * Toggle sits beside <product-options> (sibling under a shared parent).
   * Prefer the local pair so quick-view / cards don't grab the main PDP root.
   */
  function findOptionsRoot(toggleBtn) {
    if (!toggleBtn) return null;

    var filterWrap = toggleBtn.closest('[data-variant-stock-filter]');
    var productId = productIdFrom(toggleBtn);
    var scope =
      (filterWrap && filterWrap.parentElement) ||
      toggleBtn.closest('.product-details__options, .quick-add, .quick-view, [data-modal-wrapper], dialog') ||
      toggleBtn.parentElement;

    if (scope) {
      if (productId) {
        var local = scope.querySelector('[data-product-options="' + productId + '"]');
        if (local) return local;
      }
      var any = scope.querySelector(OPTIONS_SEL);
      if (any) return any;
    }

    if (productId) {
      return document.querySelector('[data-product-options="' + productId + '"]');
    }
    return null;
  }

  function findToggleForRoot(root) {
    if (!root) return null;
    var productId = productIdFrom(root);
    var scope =
      root.closest('.product-details__options, .quick-add, .quick-view, [data-modal-wrapper], dialog') ||
      root.parentElement;
    if (scope && productId) {
      var local = scope.querySelector(
        '.variant-stock-toggle[data-product-id="' + productId + '"]'
      );
      if (local) return local;
    }
    if (productId) {
      return document.querySelector('.variant-stock-toggle[data-product-id="' + productId + '"]');
    }
    return null;
  }

  function isFilterOn(root) {
    return !!root && !!root.querySelector('.product-options__inputs.' + FILTER_CLASS);
  }

  function isOptionOutOfStock(optionEl) {
    if (!optionEl) return false;
    if (optionEl.getAttribute('data-is-in-stock') === 'false') return true;
    return !!optionEl.querySelector(UNAVAILABLE_SEL);
  }

  function isSelectedVariantOos(root) {
    if (!root) return false;
    var checked = root.querySelector('.product-option__input:checked');
    if (!checked) return false;
    var option = checked.closest && checked.closest('.product-option');
    return isOptionOutOfStock(option);
  }

  function markOutOfStock(root) {
    if (!root) return;
    root.querySelectorAll('.product-option--swatch').forEach(function (swatch) {
      swatch.classList.toggle(OOS_CLASS, isOptionOutOfStock(swatch));
    });
  }

  function ensureInStockSelected(root) {
    if (!root || !isSelectedVariantOos(root)) return;
    var swatches = root.querySelectorAll('.product-option--swatch');
    for (var i = 0; i < swatches.length; i++) {
      if (isOptionOutOfStock(swatches[i])) continue;
      var input = swatches[i].querySelector('.product-option__input');
      if (!input || input.checked) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
  }

  function syncMessageLabels(toggleBtn, on) {
    var allLabel = toggleBtn.querySelector('.stock-message__label--all');
    var filteredLabel = toggleBtn.querySelector('.stock-message__label--filtered');
    if (allLabel) allLabel.setAttribute('aria-hidden', on ? 'true' : 'false');
    if (filteredLabel) filteredLabel.setAttribute('aria-hidden', on ? 'false' : 'true');
  }

  function applyToToggle(toggleBtn, on) {
    var root = findOptionsRoot(toggleBtn);
    if (!root) return;
    if (on) {
      markOutOfStock(root);
      ensureInStockSelected(root);
    }
    root.querySelectorAll('.product-options__inputs').forEach(function (container) {
      container.classList.toggle(FILTER_CLASS, on);
    });
    toggleBtn.classList.toggle(ACTIVE_CLASS, on);
    toggleBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
    syncMessageLabels(toggleBtn, on);
  }

  function syncInstance(toggleBtn, filterOn) {
    if (!toggleBtn) return;
    var root = findOptionsRoot(toggleBtn);
    if (!root) return;

    markOutOfStock(root);

    if (typeof filterOn === 'boolean') {
      applyToToggle(toggleBtn, filterOn);
      return;
    }

    applyToToggle(toggleBtn, toggleBtn.classList.contains(ACTIVE_CLASS));
  }

  function syncAll(filterOn) {
    ensureStylesheet();
    document.querySelectorAll(TOGGLE_SEL).forEach(function (toggleBtn) {
      syncInstance(toggleBtn, filterOn);
    });
  }

  function syncForProduct(productId, filterOn) {
    ensureStylesheet();
    if (productId == null) {
      syncAll(filterOn);
      return;
    }
    var id = String(productId);
    document
      .querySelectorAll('.variant-stock-toggle[data-product-id="' + id + '"]')
      .forEach(function (toggleBtn) {
        syncInstance(toggleBtn, filterOn);
      });
  }

  function nodeLooksRelevant(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches) {
      if (
        node.matches(TOGGLE_SEL) ||
        node.matches('[data-variant-stock-filter]') ||
        node.matches(OPTIONS_SEL)
      ) {
        return true;
      }
    }
    return !!(
      node.querySelector &&
      node.querySelector(TOGGLE_SEL + ', [data-variant-stock-filter], ' + OPTIONS_SEL)
    );
  }

  // Capture phase: wyatt-modal calls stopPropagation on [data-modal-wrapper] clicks,
  // which blocks bubble-phase document listeners inside quick-view / quick-add.
  document.addEventListener(
    'click',
    function (e) {
      var toggleBtn = e.target.closest && e.target.closest(TOGGLE_SEL);
      if (!toggleBtn) return;
      e.preventDefault();
      e.stopPropagation();
      var root = findOptionsRoot(toggleBtn);
      if (!root) return;
      applyToToggle(toggleBtn, !isFilterOn(root));
    },
    true
  );

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-product-option]')) return;
    var root = e.target.closest && e.target.closest(OPTIONS_SEL);
    if (!root) return;
    var toggleBtn = findToggleForRoot(root);
    markOutOfStock(root);
    if (toggleBtn && isFilterOn(root)) {
      ensureInStockSelected(root);
    }
  });

  document.addEventListener('product:options-updated', function (e) {
    var productId = e && e.detail && e.detail.productId;
    syncForProduct(productId);
  });

  if (typeof MutationObserver !== 'undefined') {
    var syncTimer = null;
    var observer = new MutationObserver(function (mutations) {
      var shouldSync = false;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (nodeLooksRelevant(added[j])) {
            shouldSync = true;
            break;
          }
        }
        if (shouldSync) break;
      }
      if (!shouldSync) return;
      // Debounce: product-options replaceDOM + quick-view inject fire many mutations.
      clearTimeout(syncTimer);
      syncTimer = setTimeout(function () {
        syncAll();
      }, 50);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  window.__bbVariantStockFilterSync = function (productId) {
    syncForProduct(productId);
  };

  function init() {
    ensureStylesheet();
    syncAll(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
